<p-dialog header="Create TA from Template"
          [visible]="visible()"
          (visibleChange)="visible.set($event)"
          [modal]="true"
          [style]="{width: '28rem'}"
          data-testid="create-ta-from-template-dialog">
  <div class="flex flex-col gap-4 text-sm font-['Inter']">
    <div class="text-surface-700">
      Create a new TA based on <b>{{ template()?.name }}</b>. The itinerary's first day will start on the date you choose.
    </div>
    <div class="flex flex-col gap-2">
      <label for="template-start-date"><span class="text-text-color">Travel Start Date</span><span class="text-red-700">*</span></label>
      <p-datepicker inputId="template-start-date"
                    [ngModel]="startDate()"
                    (ngModelChange)="startDate.set($event)"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [dateFormat]="'dd/mm/yy'"
                    [readonlyInput]="true"
                    placeholder="DD/MM/YY"
                    size="small"
                    appendTo="body"
                    data-testid="create-ta-from-template-start-date"
      ></p-datepicker>
    </div>
  </div>
  <ng-template #footer>
    <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="visible.set(false)"></p-button>
    <p-button label="Create TA"
              [disabled]="!startDate() || store.isSavingData()"
              (onClick)="create()"
              data-testid="create-ta-from-template-confirm"></p-button>
  </ng-template>
</p-dialog>
